<template>
    <a-card title="历史数据分析">
        <a-spin :spinning="tLoading"></a-spin>
        <div class="formItem">
            <label for="">统计方式：</label>
            <a-radio-group v-model="dataType" @change="handleTypeChange">
                <a-radio-button value="day">
                    按天统计
                </a-radio-button>
                <a-radio-button value="week">
                    按周统计
                </a-radio-button>
                <a-radio-button value="month">
                    按月统计
                </a-radio-button>
            </a-radio-group>
        </div>
        
        <div class="formItem">
            <label for="">时间范围：</label>
            <timeSelecter ref="timeRangeId" :dataType="dataType" :startDate="sumData.startDate" @timeChange="handleTimeChange"></timeSelecter>

            <label for="" class="ml20">选择应用：</label>

            <a-select style="width: 150px" show-search v-model="selectedSys" placeholder="选择系统" @change="handleChange">
                <a-select-option v-for="item in ableSys" :key="item">
                    {{ item }}
                </a-select-option>
            </a-select>

            <a-button class="searchItem" type="primary" @click="handleSubmit1()" style="margin-left:20px;">查询</a-button>
            <a-button class="searchItem" type="primary" @click="handleReset">重置</a-button>
            
        </div>



        <a-row :gutter="[16,16]" id="homeWarnChartBox">
            <a-col :span="12">
                <qschart :data="sumData" :chartID="'his1qschart'"></qschart>
            </a-col>
            <a-col :span="12">
                <qsPie ref="historyPie" :pid="'historyPie1'"></qsPie>
            </a-col>
        </a-row>

        
        <a-row :gutter="[16,16]" id="homeWarnChartBox">
        <a-col :span="24">
            <label for="">时间范围：</label>

            <timeSelecter :dataType="dataType" :startDate="sumData2.startDate" @timeChange="handleTime2Change"></timeSelecter>

            <a-button class="searchItem" type="primary" @click="handleSubmit2()" style="margin-left:20px;">查询</a-button>
 
        </a-col>
        </a-row>

        <a-row :gutter="[16,16]" id="homeWarnChartBox">
        <a-col :span="12">
                <qschart :data="sumData2" :chartID="'his2qschart'"></qschart>
            </a-col>
            <a-col :span="12">
                <qsPie ref="historyPie2" :pid="'historyPie2'"></qsPie>
            </a-col>
        </a-row>
        </a-card>
</template>

<script>
import qschart from '../overview/qschart'
import timeSelecter from './timepicker'
import qsPie from './hpie'

export default {
    components:{
        qschart,
        qsPie,
        timeSelecter
    },
    data(){
        return {
            ableDate:[],
            ableSys:[],
            tLoading:false,

            dataType:'day',
            
            selectedSys:[],

            sumData:{
                startDate:new Date().Format("yyyy/MM/dd"),
                endDate:new Date().Format("yyyy/MM/dd"),
                listthread:[],
                isoverview:false,
                isperhour:true,
            },

            sumData2:{
                startDate:new Date(new Date().getTime() - 24 * 60 * 60 * 1000).Format("yyyy/MM/dd"),
                endDate:new Date(new Date().getTime() - 24 * 60 * 60 * 1000).Format("yyyy/MM/dd"),
                listthread:[],
                isoverview:false,
                isperhour:true,
            },
            submitType : 1,
        }
    },
    methods:{
        handleTypeChange(){
            let type = this.dataType;
            this.sumData.isperhour = type == 'day' ? true : false;
            this.sumData2.isperhour = type == 'day' ? true : false;
            if(type == 'week'){
                let targetD = this.G.getRecentDate('3')
                this.sumData.startDate = new Date(targetD.start_time).Format("yyyy/MM/dd");
                this.sumData.endDate = new Date(targetD.end_time).Format("yyyy/MM/dd");
                
            }
        },

        //选择系统改变
        handleChange(value) {
            this.selectedSys = value;
        },
        //选择时间
        handleTimeChange(value) {
            this.sumData.startDate = value.startDate;
            this.sumData.endDate = value.endDate;
        },
        //选择时间2
        handleTime2Change(value){
            this.sumData2.startDate = value.startDate;
            this.sumData2.endDate = value.endDate;
        },
        getHistorySelecter(){
            let that = this;
           
            let params = {
                urlparams:false
            };
            that.tLoading = true;
            that.$store.dispatch({
                type: "logservice/queryhistorysys",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let targetData = res.data.data;
                    that.ableDate = that.forMatDate(targetData.listDate);
                    that.ableSys = targetData.listSys;
                    that.selectedSys = that.ableSys[0];
                    that.handleSubmit1();
                    that.handleSubmit2();

                }
                that.tLoading = false;

            }).catch(() => {
                that.tLoading = false;
            });
        },
        forMatDate(targetDate){
            let result = [];
            targetDate.forEach(element => {
                result.push(new Date(element).Format('yyyy-MM-dd'));
            });
            return result
        },
        handleSubmit1(){
            let that = this;
            let params = {
                startDate: that.sumData.startDate,
                endDate:that.sumData.endDate,
                selectedSys:that.selectedSys,
                perDay: that.dataType == 'day',
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/gethistorychart",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.sumData.listthread = res.data.data;
                    that.$refs.historyPie.analystData(that.selectedSys,that.sumData.startDate,that.sumData.endDate)
                }

            }).catch(() => {
            });

        },
        handleSubmit2(){
            let that = this;
            let params = {
                startDate: that.sumData2.startDate,
                endDate:that.sumData2.endDate,
                selectedSys:that.selectedSys,
                perDay: that.dataType == 'day',
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/gethistorychart",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.sumData2.listthread = res.data.data;
                    that.$refs.historyPie2.analystData(that.selectedSys,that.sumData2.startDate,that.sumData2.endDate)
                }

            }).catch(() => {
            });

        },
        handleReset(){
            this.dataType='day',
            this.selectedSys=[],
            this.sumData.listthread = [];
        }
    },

    mounted(){
        this.getHistorySelecter();
    }
};
</script>

<style lang="less" scoped>
    .formItem{
        width:100%;
        height: auto;
        margin-bottom: 20px;
    }

    .formItem label{
        margin-right: 20px;
    }

    .searchItem{
        margin-right: 20px;
    }

</style>
